<template>
  <div>
    <div class="layout">
      <div class="blackListManagement">
        <div class="layout-header" ref="searchBox">
          <div class="infor-layout-header">
            <span class="title">用户黑名单信息</span>
          </div>
          <el-form
            :inline="true"
            :model="form"
            class="demo-form-inline"
            size="small">
            <el-form-item label="品牌名称">
              <el-select v-model="form.brandId" style="width: 120px">
                <el-option label="全部" value="all"></el-option>
                <el-option
                  :label="item.value"
                  :value="item.key"
                  v-for="item in brands"
                  :key="item.key"/>
              </el-select>
            </el-form-item>
            <el-form-item label="手机号码">
              <el-input v-model="form.mobile" style="width: 150px"/>
            </el-form-item>
            <el-form-item label="用户姓名">
              <el-input v-model="form.consumerName" style="width: 150px"/>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSearch">查询</el-button>
              <el-button @click="onReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div style="height: 10.3125rem"></div>
        <div class="pagination-bg-white layout-header">
          <el-table
            v-show="checkUserAuth(4, 14)"
            v-loading.body="tableLoading"
            :data="tableData"
            :max-height="tableViewHeight"
            width="100%"
            highlight-current-row>
            <el-table-column prop="index" label="序号" align="center">
              <template v-slot="props">
                <span>{{ props.$index + 1 + (formData.pageNum - 1) * formData.pageSize }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="brandName" label="品牌名称" align="center"></el-table-column>
            <!-- 手机号脱敏展示 -->
            <el-table-column label="手机号码" align="center">
              <template v-slot="props">
                {{ maskMobile(props.row.mobile) }}
              </template>
            </el-table-column>
            <!-- 姓名脱敏展示 -->
            <el-table-column label="用户姓名" align="center">
              <template v-slot="props">
                {{ maskName(props.row.consumerName) }}
              </template>
            </el-table-column>
            <el-table-column prop="num" label="扣分" align="center"></el-table-column>
            <el-table-column prop="createTime" label="创建时间" sortable></el-table-column>
          </el-table>
          <el-pagination
            style="margin-top: 15px; text-align: right"
            @size-change="handleSizeChange"
            @current-change="pageNoChange"
            :current-page="formData.pageNum"
            :page-sizes="pageSizes"
            :page-size="formData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
          <div v-show="!checkUserAuth(4, 216)">您的账户没有权限查看此内容！</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api'
import { mapGetters } from 'vuex'
export default {
  name: 'blackListManagement',
  data() {
    return {
      form: {
        brandId: 'all',
        mobile: '',
        consumerName: ''
      },
      tableViewHeight: 50,
      tableLoading: true,
      tableData: [],
      formData: {
        pageNum: 1,
        pageSize: 20
      },
      total: 0,
      pageSizes: [10, 20, 50],
      mockData: [
        { brandId: 111, brandName: '哈啰电单', mobile: '13800138000', consumerName: '郭东旭', num: 9, createTime: '2026-01-01 10:00:35' },
        { brandId: 114, brandName: '人民出行', mobile: '13912345678', consumerName: '程庚', num: 9, createTime: '2026-01-08 15:12:26' },
        { brandId: 114, brandName: '人民出行', mobile: '13788889999', consumerName: '何宇', num: 12, createTime: '2026-02-16 13:16:19' },
        { brandId: 111, brandName: '哈啰电单', mobile: '15012345678', consumerName: '秦田新', num: 9, createTime: '2026-02-23 09:46:53' },
        { brandId: 116, brandName: '星骑出行', mobile: '18987654321', consumerName: '刘林根', num: 12, createTime: '2026-03-05 14:56:10' },
        { brandId: 116, brandName: '星骑出行', mobile: '13666667777', consumerName: '刘洋', num: 9, createTime: '2026-03-06 15:23:08' }
      ]
    }
  },
  computed: {
    ...mapGetters(['user', 'selfAreaId', 'brands', 'userBikeType'])
  },
  filters: {
    filterBrandName(value, brands) {
      return brands.some(item => String(item.brandId) === String(value))
        ? brands.find(item => String(item.brandId) === String(value)).brandName
        : undefined
    }
  },
  created() {
    if (this.userBikeType === 2) {
      this.form.bikeType = 'all'
      this.disabled = false
    } else {
      this.form.bikeType = this.userBikeType
      this.disabled = true
    }
    this.onSearch()
  },
  methods: {
    // 手机号脱敏：前3位保留，后面替换为*
    maskMobile(mobile) {
      if (!mobile || mobile.length !== 11) return mobile
      return mobile.substring(0, 3) + '********'
    },
    // 姓名脱敏：第一个字保留，后面替换为*
    maskName(name) {
      if (!name) return name
      return name.substring(0, 1) + '*'.repeat(name.length - 1)
    },
    onSearch() {
      this.tableLoading = true
      // 模拟接口请求（注释原接口，改用测试数据）
      // const params = {
      //   selfAreaId: this.selfAreaId,
      //   currentPage: this.formData.pageNum,
      //   pageSize: this.formData.pageSize,
      //   mobile: this.form.mobile,
      //   consumerName: this.form.consumerName
      // }
      // if (this.form.brandId !== 'all') {
      //   params.brandId = this.form.brandId
      // }
      // Api.getBikeSyncList(params).then((res) => {
      //   this.tableLoading = false
      //   if (res.code === 200 && res.data) {
      //     this.tableData = res.data.lists
      //     this.total = res.data.total
      //   } else {
      //     this.$message.warning(res.message)
      //   }
      //   this.calcView()
      // })

      // 模拟接口返回测试数据
      setTimeout(() => {
        // 1. 基础筛选逻辑
        let filteredData = [...this.mockData]
        // 按品牌筛选（brandId）
        if (this.form.brandId !== 'all') {
          filteredData = filteredData.filter(item => item.brandId === this.form.brandId)
        }
        // 按手机号筛选（模糊匹配）
        if (this.form.mobile) {
          filteredData = filteredData.filter(item =>
            item.mobile.includes(this.form.mobile.trim())
          )
        }
        // 按用户姓名筛选（模糊匹配）
        if (this.form.consumerName) {
          filteredData = filteredData.filter(item =>
            item.consumerName.includes(this.form.consumerName.trim())
          )
        }
        // 2. 分页处理
        this.total = filteredData.length
        const start = (this.formData.pageNum - 1) * this.formData.pageSize
        const end = start + this.formData.pageSize
        this.tableData = filteredData.slice(start, end)
        // 3. 结束加载&计算表格高度
        this.tableLoading = false
        this.calcView()
      }, 500)
    },
    pageNoChange(page) {
      this.formData.pageNum = page
      this.onSearch()
    },
    handleSizeChange(size) {
      this.formData.pageSize = size
      this.onSearch()
    },
    onReset() {
      this.form.brandId = 'all'
      this.form.mobile = ''
      this.form.consumerName = ''
      this.onSearch()
    },
    calcView() {
      this.$nextTick(() => {
        let H = 0
        if (this.$refs.searchBox && this.$refs.searchBox.clientHeight) {
          H += Number(this.$refs.searchBox.clientHeight)
        }
        // 56: 导航栏高度修正
        // 79: table分页器高度修正
        this.tableViewHeight = window.innerHeight - 56 - H - 96 - 56
      })
    }
  }
}
</script>

<style lang="less" scoped>
.blackListManagement {
  background:rgba(240,242,245,1);
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
.layout-header {
  margin: 16px;
  width: calc(98% - 20px);
}
.demo-form-inline{
  margin-top: 24px;
}
::v-deep .el-table::before {
  left: 0 !important;
  bottom: 0 !important;
  width: 100% !important;
  height: 0.0625rem !important;
}
::v-deep .el-table--border::after, .el-table--group::after, .el-table::before {
  content: '' !important;
  position: absolute !important;
  background-color: #EBEEF5 !important;
  z-index: 1 !important;
}
</style>
